import { prepRouteMatcher } from "app/PrimaryRouter";
/**
 * PrimaryRoutes
 */
import { prepTvGuideRoute } from "pages/tvguide/route";
import { prepSecondaryRouter, prepGetSecondaryRouterData, prepSecondaryRouterRoute, } from "app/SecondaryRouter";
/**
 * SecondaryRoutes
 */
import { articleRoute } from "pages/article";
import { basicRoute } from "pages/basic/prepped";
import { contestRoute } from "pages/contest/prepped";
import { prepInteractiveRoute } from "pages/interactive";
import { videoRoute } from "pages/video/prepped";
import { participateRoute } from "pages/participate/prepped";
import { prepProgramRoute, ProgramView } from "pages/program";
import { prePrepHomeRoute } from "pages/home/prepped";
import { programsRoute } from "pages/programs/prepped";
import { Tickets } from "pages/Tickets";
export function getPreppedPrimaryRouteMatcher(detailsController, headController) {
    var secondaryRoutes = [
        articleRoute,
        basicRoute,
        contestRoute,
        programsRoute,
        prePrepHomeRoute(),
        prepInteractiveRoute(detailsController),
        participateRoute,
        prepProgramRoute(ProgramView, detailsController),
        videoRoute,
        Tickets.route,
    ];
    var getData = prepGetSecondaryRouterData(secondaryRoutes);
    var secondaryRouter = prepSecondaryRouter(getData);
    var routes = [prepTvGuideRoute(headController)];
    return prepRouteMatcher(routes, prepSecondaryRouterRoute(secondaryRouter));
}
